module.exports = __webpack_public_path__ + "media/images/courses/rpf-logo-3834de48236978cdccf07809f3fac813.svg";